import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

export default function ProductsDetail({products, ...rest}) {
  return (
    <div>
        {products.map((product) => (
            <Accordion sx={{maxWidth: '300px' }} onClick={(e) => e.stopPropagation()}>
                <AccordionSummary
                    sx={{userSelect: 'text!important'}}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${product.id}-content`}
                    id={`${product.id}-header`}
                >
                    {product.sku}, {product.asin}
                </AccordionSummary>
                <AccordionDetails>
                    {product.name}
                </AccordionDetails>
            </Accordion>
        ))}
    </div>
  );
}